<div class="final_screen__container">
    <app-full-page-split [title]="description"
        [fullHeight]="false">
    </app-full-page-split>
</div>